import React from 'react';
// import PropTypes from 'prop-types';

/* This component provides a button pair. One active and one shadow. It automatically
   toggles shadow to active and active to shadow when shadow is clicked.  The component
   communicates to parent component which button was clicked by passing the text 'firstbutton'
   or 'secndbutton' to the parents onClick handler.
   Note, the buttonPressed prop is optional. Only needed if you need to simulate button clicked.
*/
export class ButtonWithShadow extends React.Component {

    constructor (props) {
        super(props);

        // Initialize first button as active and second button as shadow
        this.state = {
            firstButtonClass: "button-with-shadow-off" ,
            secndButtonClass: "button-with-shadow-on" ,
        }
    }

    // When user clicks first button, make first button active and second button the shadow
    // then fire on onClick handler passed down by parent
    onClickOfFirstButton = () => {
        this.setState({
            firstButtonClass: "button-with-shadow-off",
            secndButtonClass: "button-with-shadow-on"
        }) 
        /* let parent know button clicked by firing callback passed via props */
        this.props.onClick('firstButton');
    }

    // When user clicks second button, make second button active and first button the shadow
    // then fire on onClick handler passed down by parent
    onClickOfSecondButton = () => {
        this.setState({
            firstButtonClass: "button-with-shadow-on",
            secndButtonClass: "button-with-shadow-off"
        }) 
        /* let parent know button clicked by firing callback passed via props */
        this.props.onClick('secndButton');
    }

    
    // Return  JSX
    render() {
        let {firstButtonClass, secndButtonClass} = this.state;

        /* Following conditional statements are used to simulate a button pressed 
           This buttonPressed prop allows you to have system simulate a click by passing in this prop.
           Assuming parent is saving button clicked in local state with onClick handler, 
           all you have to do is pass that value to buttonPressed prop and will simulate logic
           for button click handlers above.  */
        if (this.props.buttonPressed === "secondButton") {
            firstButtonClass = "button-with-shadow-on"
            secndButtonClass = "button-with-shadow-off"
        }

        if (this.props.buttonPressed === "firstButton") {
            firstButtonClass = "button-with-shadow-off"
            secndButtonClass = "button-with-shadow-on"
        }

        return (
            <div className="button-shadow-container">
                <button className={firstButtonClass}
                        onClick={this.onClickOfFirstButton}
                >
                    Contributions
                </button>
                <div className="invites-button-spacer">&nbsp;</div>
                <button className={secndButtonClass}
                    onClick={this.onClickOfSecondButton}
                >
                    Helping Hands
                </button>
            </div>
            )
    }
}




// WEBPACK FOOTER //
// ./src/components/buttons/ButtonWithShadow.js